<template>
    <v-layout align-center justify-center>
        <v-flex xs12 sm8 md6 lg4>
            <v-card class="elevation-12">
                <v-form ref="loginForm" @submit.prevent="handleLogin">
                    <v-card-text>
                        <p class="text-xs-center mb-5 pt-3">
                            <img
                              style="max-width: 95%;"
                              src="@/assets/storage-360-logo.svg"
                              alt="Storage360 by Store Space">
                        </p>
                        <v-text-field
                            prepend-icon="person"
                            v-model.trim="email"
                            label="Email"
                            required
                            :rules="emailRules"
                            type="email"
                            clearable
                        ></v-text-field>
                        <v-text-field
                            prepend-icon="lock"
                            v-model.trim="password"
                            label="Password"
                            required
                            type="password"
                            clearable
                        ></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn dark color="#C8102E" @click="forgotPassword = true">Forgot Password</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn :loading="loading" dark color="#001e60" type="submit">Login</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
            <v-alert :value="registerSuccess" type="success" class="mt-4">
                Your account was created. Please login using the credentials used during registration.
            </v-alert>
            <v-dialog v-model="forgotPassword" width="400">
                <v-card>
                    <v-toolbar card dark color="#001e60">
                        <v-toolbar-title>Forgot Password</v-toolbar-title>
                        <v-spacer />
                        <v-btn icon dark @click="forgotPassword = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-text-field v-model="emailForgotten" :rules="emailRules" label="Email" required></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="#001e60" dark @click="handleForgotPassword" :loading="loading">Submit</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-flex>
    </v-layout>
</template>

<script>
import FormRules from "@/helpers/form-rules";

export default {
    data() {
        return {
            email: null,
            emailForgotten: null,
            password: null,
            emailRules: FormRules.email,
            error: false,
            registerSuccess: this.$route.query.registerSuccess ? true : false,
            loading: false,
            forgotPassword: false,
        };
    },

    methods: {
        handleLogin() {
            this.loading = true;

            this.$store
                .dispatch("loginRequest", {
                    email: this.email,
                    password: this.password,
                })
                .then(() => {
                    this.$router.push("/");
                })
                .catch(err => {
                    this.loading = false;
                });
        },

        handleForgotPassword() {
            this.loading = true;

            this.$store
                .dispatch("forgotPassword", {
                    email: this.emailForgotten,
                })
                .then(() => {
                    this.loading = false;
                    this.emailForgotten = null;
                    this.forgotPassword = false;
                })
                .catch(err => {
                    this.loading = false;
                    // do nothing since errors are handled in the store
                });
        },
    },
};
</script>